/**
 * Binds the back-navigation policy to the live store and swiper.
 * The decision itself lives in backNavigationPolicy so it stays testable.
 */

import useStore from 'state/knovStore'
import { closeTopmostModalDialog } from 'lib/topLayer'
import { closeTopmostLightbox } from 'state/openLightboxes'
import { slideTo } from 'state/imperativeApis/swiperApi'
import { getPanelBackStack, takePreviousPanel } from 'state/panelBackStack'
import {
    performBackNavigation,
    type BackNavigationDeps,
    type BackNavigationResult,
} from 'state/backNavigationPolicy'

function isPanelAvailable(panelId: string): boolean {
    return useStore.getState().panels.getIndexById(panelId) >= 0
}

function slideToPanel(panelId: string): boolean {
    const index = useStore.getState().panels.getIndexById(panelId)
    if (index < 0) return false
    slideTo(index)
    return true
}

export function createBackNavigationDeps(): BackNavigationDeps {
    return {
        closeTopLayerDialog: closeTopmostModalDialog,
        closeLightbox: closeTopmostLightbox,
        isCryptoModalOpen: () => Boolean(useStore.getState().isCryptoPayModalOpen),
        closeCryptoModal: () => useStore.getState().actions.modalActions.closeCryptoModal(),
        isModalOpen: () => Boolean(useStore.getState().isModalOpen),
        closeModal: () => useStore.getState().actions.modalActions.closeModal(),
        isStoryOpen: () => Boolean(useStore.getState().isStoryOpen),
        closeStoryModal: () => useStore.getState().actions.modalActions.closeStoryModal(),
        isSidebarOpen: () => Boolean(useStore.getState().showSidebar),
        closeSidebar: () => useStore.getState().setShowSidebar(false),
        takePreviousPanel: () => takePreviousPanel(getPanelBackStack(), isPanelAvailable),
        slideToPanel,
    }
}

export function navigateBack(): BackNavigationResult {
    return performBackNavigation(createBackNavigationDeps())
}
